export const fullWindowTemplateId = "730d4969-400d-8c2a-615a-7a70766b27d8";
export const pldmTemplateId = "31fb156d-7c0d-11f0-969e-00163e31e0bb";

export const orderTypeMap = {
  "name": 1,
  "createUserName": 2,
  "createdAt": 3,
  "updatedAt": 4
}